const useCountryCheck = (countries: string[]) => {
  const currentShop = useCurrentShop()

  const isInList = computed(() => countries.includes(currentShop.value.locale))

  return { isInList }
}

export default useCountryCheck
